import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { DialogApprovalsEquipmentsRejectComponent } from './dialog-approvals-reject.component';

@NgModule({
    entryComponents: [
        DialogApprovalsEquipmentsRejectComponent
    ],
    declarations: [
        DialogApprovalsEquipmentsRejectComponent
    ],
    imports: [
        TranslateModule,

        FuseSharedModule,

        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatInputModule
    ],
    exports: [
        DialogApprovalsEquipmentsRejectComponent
    ]
})
export class DialogApprovalsEquipmentsRejectModule {
}
